// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportObjects = {
	27258: function() {
		return {
			"./cardano_multiplatform_lib_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache0["ug$"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache1["h4u"](p0i32,p1i32);
				},
				"__wbindgen_json_parse": function(p0i32,p1i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache2["t$0"](p0i32,p1i32);
				},
				"__wbindgen_string_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache3["qtq"](p0i32,p1i32);
				},
				"__wbg_getRandomValues_fb6b088efb6bead2": function(p0i32,p1i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache4["sPz"](p0i32,p1i32);
				},
				"__wbg_randomFillSync_654a7797990fb8db": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache5["mmj"](p0i32,p1i32,p2i32);
				},
				"__wbg_static_accessor_NODE_MODULE_33b45247c55045b0": function() {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache6["wAS"]();
				},
				"__wbg_process_70251ed1291754d5": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache7["pk_"](p0i32);
				},
				"__wbindgen_is_object": function(p0i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache8["WlW"](p0i32);
				},
				"__wbg_versions_b23f2588cdb2ddbb": function(p0i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache9["uaI"](p0i32);
				},
				"__wbg_node_61b8c9a82499895d": function(p0i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache10["NTm"](p0i32);
				},
				"__wbindgen_is_string": function(p0i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache11["eYF"](p0i32);
				},
				"__wbg_require_2a93bc09fee45aca": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache12["qcl"](p0i32,p1i32,p2i32);
				},
				"__wbg_crypto_2f56257a38275dbd": function(p0i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache13["mR8"](p0i32);
				},
				"__wbg_msCrypto_d07655bf62361f21": function(p0i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache14["ZLW"](p0i32);
				},
				"__wbg_call_ba36642bd901572b": function(p0i32,p1i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache15["qwE"](p0i32,p1i32);
				},
				"__wbg_newnoargs_9fdd8f3961dd1bee": function(p0i32,p1i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache16["ULK"](p0i32,p1i32);
				},
				"__wbg_self_bb69a836a72ec6e9": function() {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache17["tSO"]();
				},
				"__wbg_window_3304fc4b414c9693": function() {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache18["R$s"]();
				},
				"__wbg_globalThis_e0d21cabc6630763": function() {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache19["md1"]();
				},
				"__wbg_global_8463719227271676": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache20["IFv"]();
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache21["XP4"](p0i32);
				},
				"__wbg_buffer_9e184d6f785de5ed": function(p0i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache22["zPx"](p0i32);
				},
				"__wbg_new_e8101319e4cf95fc": function(p0i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache23["tdw"](p0i32);
				},
				"__wbg_set_e8ae7b27314e8b98": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache24["CtR"](p0i32,p1i32,p2i32);
				},
				"__wbg_length_2d56cb37075fcfb1": function(p0i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache25["uQr"](p0i32);
				},
				"__wbg_newwithlength_a8d1dbcbe703a5c6": function(p0i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache26["RVT"](p0i32);
				},
				"__wbg_subarray_901ede8318da52a6": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache27["iYX"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache28["m_1"](p0i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache29["fYP"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache30["Or8"](p0i32,p1i32);
				},
				"__wbindgen_rethrow": function(p0i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache31["nDt"](p0i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[13866].exports;
					return wasmImportedFuncCache32["oHO"]();
				}
			}
		};
	},
};

var wasmModuleMap = {
	"13866": [
		27258
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"13866":{"27258":"a234fe82115a9750a0e7"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};